@if (surveyEditorService.surveyEditor$().activeQuestion; as activeQuestion) {
  <form [formGroup]="activeQuestion">
    <div class="question-form__array">
      <div class="header row">
        <span class="label">Information Page</span>
      </div>
      <empathy-text-editor
        [id]="activeQuestion.value.id"
        [control]="surveyEditorService.surveyEditor$().activeQuestionInformation"
        [settings]="infoSettings"
        [allowLineBreaks]="true"
        [stopDefaultTab]="true"
      >
      </empathy-text-editor>
    </div>
  </form>
}
